import PropTypes from 'prop-types';
import { Icon } from '@bwoty-web/ui-kit';
import { UI_CHEVRON_RIGHT } from '@bwoty-web/ui-kit/icons';
import './linkPush.scss';

const LinkPush = ({
  children,
  href = null,
  onClick = null,
  target = null,
  ...rest
}) => {
  const isButton = !href;
  const RenderType = isButton ? 'button' : 'a';

  return (
    <RenderType
      {...rest}
      target={target}
      href={href}
      onClick={() => onClick()}
      className="gw-link-push"
    >
      {children}
      <Icon
        className="gw-link-push__icon"
        path={UI_CHEVRON_RIGHT}
        size="xs"
      />
    </RenderType>
  );
};

LinkPush.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  target: PropTypes.string,
};

export default LinkPush;
